declare global {
    interface Window {
        env: any
    }
}

type EnvType = {
    REACT_APP_B2C_CLIENTID: string,
    REACT_APP_B2C_AUTHORITY: string,
    REACT_APP_B2C_KNOWN_AUTHORITIES: string,
    REACT_APP_B2C_POST_LOGOUT_REDIRECT_URL: string,
    REACT_APP_B2C_READ_SCOPE: string,
    REACT_APP_B2C_USER_IMPERSONATION_SCOPE: string,
    REACT_APP_B2C_REDIRECT_URL: string,
    EXTERNAL_REDIRECT_URL: string,
    REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY: string,
};

// eslint-disable-next-line import/prefer-default-export
export const env: EnvType = {
    REACT_APP_B2C_CLIENTID: (<any>window).REACT_APP_B2C_CLIENTID,
    REACT_APP_B2C_AUTHORITY: (<any>window).REACT_APP_B2C_AUTHORITY,
    REACT_APP_B2C_KNOWN_AUTHORITIES: (<any>window).REACT_APP_B2C_KNOWN_AUTHORITIES,
    REACT_APP_B2C_POST_LOGOUT_REDIRECT_URL: (<any>window).REACT_APP_B2C_POST_LOGOUT_REDIRECT_URL,
    REACT_APP_B2C_READ_SCOPE: (<any>window).REACT_APP_B2C_READ_SCOPE,
    REACT_APP_B2C_USER_IMPERSONATION_SCOPE: (<any>window).REACT_APP_B2C_USER_IMPERSONATION_SCOPE,
    REACT_APP_B2C_REDIRECT_URL: (<any>window).REACT_APP_B2C_REDIRECT_URL,
    REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY: (<any>window).REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY,
    EXTERNAL_REDIRECT_URL: (<any>window).EXTERNAL_REDIRECT_URL,
};
